import React, { useEffect, useMemo, useState } from 'react';

import cn from 'classnames';

import inspectionLogo from 'assets/images/inspection/inspection-logo.svg';
import { ReturnComponentType } from 'common';
import './FileUploader.scss';
import { useAppSelector, useDragAndDrop } from 'hooks';
import { selectCertainInspection } from 'state';
import { Button } from 'ui-kit';

type FileUploaderType = {
  isBlockUpload: boolean;
  files: File[];
  setFiles: (files: File[]) => void;
  showPreviewFile?: File;
  setNotification?: (message: string) => void;
};
export const FileUploader = ({
  isBlockUpload,
  files,
  setFiles,
  showPreviewFile,
  setNotification,
}: FileUploaderType): ReturnComponentType => {
  const [url, setUrl] = useState<string>();
  const inspection = useAppSelector(selectCertainInspection);

  const { onDragOver, onDrop, handleFiles, fileInput } = useDragAndDrop({
    files,
    setFiles,
    setNotification,
  });

  useEffect(() => {
    if (showPreviewFile) {
      setUrl(URL.createObjectURL(showPreviewFile));
    }
  }, [showPreviewFile]);

  const acceptFilesType = useMemo(() => {
    if (inspection?.files && Object.values(inspection?.files).length) {
      if (
        Object.values(inspection?.files)?.flat(1)[0]?.key?.toLowerCase().slice(-3) !==
        'mp4'
      ) {
        return '.jpg,.jpeg,.png';
      }
      if (
        Object.values(inspection?.files)?.flat(1)[0]?.key?.toLowerCase().slice(-3) ===
        'mp4'
      ) {
        return '.mp4';
      }
    }

    return '.jpg,.jpeg,.png,.mp4';
  }, [inspection?.files]);

  const handleClick = (event: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    const { target = {} } = event || {};

    // @ts-ignore
    target.value = '';
  };

  const previewFile = useMemo(() => {
    return (
      <div className="FileUploader_Preview">
        {showPreviewFile &&
          (showPreviewFile.type.startsWith('image/') ? (
            <img
              src={url}
              alt={showPreviewFile?.name}
              className="FileUploader_Preview_File"
            />
          ) : (
            // eslint-disable-next-line jsx-a11y/media-has-caption
            <video src={url} className="FileUploader_Preview_File" />
          ))}
        <section>
          <img
            src={inspectionLogo}
            alt="inspection-logo"
            className="FileUploader_Preview_Logo"
          />
          <div>Upload a New Photo&Video</div>
          <p>Click in the button or drag and drop your file here</p>
          <Button onClick={() => fileInput?.current?.click()} isDisabled={isBlockUpload}>
            Upload a File
          </Button>
        </section>
      </div>
    );
  }, [url, showPreviewFile, isBlockUpload, fileInput]);

  return (
    <div
      className={cn('FileUploader', showPreviewFile && 'FileUploader__active')}
      onDragOver={onDragOver}
      onDrop={onDrop}
    >
      {previewFile}

      <input
        type="file"
        accept={acceptFilesType}
        ref={fileInput}
        multiple
        hidden
        onChange={e => {
          if (e?.target?.files?.length && e.target.files.length > 0) {
            handleFiles(e.target.files);
          }
        }}
        onClick={handleClick}
      />
    </div>
  );
};
